<template>
    <div class="user-block">
        <h3>Bump bid</h3>
        <div>
            <div class="form-row agent-fees">
                <b-form-group class="col-md-12">
                    <div class="container">
                        <template v-if="modelData && modelData.ranges">
                            <template v-for="(range, index) in modelData.ranges" >
                                <div class="row">
                                    <div class="col-2 col-sm-2">{{range.price_min}}</div>
                                    <div class="col-md-1">-</div>
                                    <b-form-group class="col-md-3"
                                                  :state="rangeFieldState(index)">
                                        ¥
                                        <b-form-input
                                            type="number"
                                            placeholder="max"
                                            step="1000"
                                            :state="rangeFieldState(index)"
                                            :id="getId('ranges'+index+'price_max')"
                                            v-model.number="modelData.ranges[index].price_max"
                                            @input="onMaxInput(index, $event)"/>
                                    </b-form-group>
                                    <div class="col-md-1">=</div>

                                    <b-form-group class="col-md-3">
                                        ¥
                                        <b-form-input type="number" placeholder="bump bid(yen)" :id="getId('ranges'+index+'fee')" v-model.number="modelData.ranges[index].fee" @input="onInput" step="1000"/>
                                    </b-form-group>
                                    <div class="col-md-1"><b-btn class="btn" @click="removeAgentRow(index)">Remove</b-btn></div>
                                </div>
                                <div v-if="rangeFieldState(index) === false" class="row align-items-center">
                                    <div class="alert alert-danger">
                                        <div v-for="err in rangeFieldError(index)">- {{err}}</div>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <div class="isolated-add-button row">
                            <div class="col-md-12"><b-btn class="btn" @click="addAgentRow">Add bump</b-btn></div>
                        </div>
                        <div v-if="modelData" class="increase row">
                            <div class="">
                                Increase bid by
                                <b-form-input type="number" :id="getId('bump_bid_step_value')" v-model.number="modelData.bump_bid_step_value" @input="onInput" step="1000"/>
                                every <b-form-input type="number" :id="getId('bump_bid_step')" v-model.number="modelData.bump_bid_step" @input="onInput" step="1000"/>
                                yen for bids over <b-form-input type="number" :id="getId('bump_bid_step_after')" v-model.number="modelData.bump_bid_step_after" @input="onInput" step="1000"/>
                            </div>
                        </div>
                    </div>
                </b-form-group>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState, mapActions } from 'vuex'
    import {splitObjKey, objLookup, getExceptionErrorMessage, getHttpValidationErrors} from '../../util/common'

    import BootstrapValidation from '../../mixins/bootstrap-validation';
    export default {
        props: [
            'value',
        ],
        mixins: [BootstrapValidation],
        data() {
            return {
                modelData: null,
                modelDataEmit: null,
                addBidBumpRow: {
                    min: null,
                    max: null,
                    fee: null,
                },
                rangeInvalidFeedback: 'This range must be greater than min value',
                rangeInvalidFeedbackMin: 'This range must be greater than the previous max',
            }
        },
        mounted() {
            this.modelData = this.value || {
                ranges: [],
                bump_bid_step_value: 0,
                bump_bid_step: 0,
                bump_bid_step_after: 0,

            };
            this.modelDataEmit = this.modelData;
            if (this.modelData && this.modelData.ranges && this.modelData.ranges.length) {
                this.addBidBumpRow.min = this.modelData.ranges[this.modelData.ranges.length-1].price_max + 1;
            }
        },
        computed: {
        },
        methods: {
            onMaxInput(index, e) {
                if (index < this.modelData.ranges.length-1) {
                    this.modelData.ranges[index+1].price_min = this.modelData.ranges[index].price_max;
                } else if (index === this.modelData.ranges.length-1){
                    this.addBidBumpRow.min = this.modelData.ranges[index].price_max + 1;
                }
                this.emitInput();
            },
            getId(name){
                return name;
            },
            onInput(){
                this.emitInput();
            },
            removeAgentRow(index){
                this.modelData.ranges = this.modelData.ranges.filter((range, i) => i !== index)
                this.modelData.ranges[0].price_min = 0
                this.emitInput();
            },
            addAgentRow(){
                const last_index = this.modelData.ranges.length - 1
                const price_min = this.modelData.ranges[last_index] ? this.modelData.ranges[last_index].price_max : 0
                const fee = 10000
                this.modelData.ranges.push({
                    price_min,
                    price_max: null,
                    fee,
                });
                this.emitInput();
            },
            emitInput(){
                let valid = true;
                this.modelData.ranges.forEach((fee, index) => {
                    if (this.rangeFieldState(index) !== null) {
                        valid = false;
                    }
                });
                if (valid) {
                    this.modelDataEmit = this.modelData;
                }
                this.$emit('input', this.modelDataEmit);
            },
            rangeFieldState(index){
                const error = this.rangeFieldError(index)
                if (!error.length) {
                    return null
                }
                return false
            },

            rangeFieldError(index){
                const last_index = this.modelData.ranges.length - 1
                const current = this.modelData.ranges[index]
                const prev = this.modelData.ranges[index-1]
                const next = this.modelData.ranges[index+1]
                const errors = []
                if (last_index !== index && !current.price_max) {
                    errors.push('Please enter a range')
                }
                if (current && !current.fee) {
                    errors.push('The bump cannot be empty')
                } else {
                    if (current.fee % 1000 > 0) {
                        errors.push('Bump must be multiple of 1000')
                    }
                    if (prev && current.fee === prev.fee) {
                        errors.push('This row is redundant, the bump is the same as previous')
                    }
                }
                if (current && current.price_min && current.price_max && current.price_max <= current.price_min) {
                    errors.push('This value must be greater than the previous one')
                }
                if (prev && current.price_min - prev.price_max > 1) {
                    errors.push('There is a gap between the min and max of the 2 highlights rows')
                }
                if (last_index === index && current.price_max) {
                    errors.push('The last row must be empty. Add a new row or make it empty')
                }
                if (next && next.price_min && current.price_max && current.price_max > next.price_min) {
                    errors.push('This value must be equal to the next row. Please adjust to fix it.')
                }
                return errors
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/User/BumpBids.vue